import { Card, Tree } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type CtsModuleSettingDataFragment } from '../../../../../api/fragments/CtsModuleSettingData';
import { type CtsModuleSpecsFragment } from '../../../../../api/fragments/CtsModuleSpecs';
import NoItemResult from '../../../../../components/results/NoItemResult';
import useTranslatedString from '../../../../../utilities/useTranslatedString';

type CtsSettingTabInsuranceProductProps = {
    module: CtsModuleSpecsFragment;
    setting: CtsModuleSettingDataFragment;
};

const CtsSettingTabInsuranceProduct = ({ module, setting }: CtsSettingTabInsuranceProductProps) => {
    const { t } = useTranslation(['ctsModuleDetails']);
    const translatedString = useTranslatedString();

    const treeData = useMemo(
        () =>
            setting.insuranceProducts.map(insurer => ({
                key: insurer.id,
                title: translatedString(insurer.legalName),
            })),
        [setting.insuranceProducts, translatedString]
    );

    if (treeData.length === 0) {
        return <NoItemResult subTitle={t('ctsModuleDetails:tabs.insuranceProducts.noData')} />;
    }

    return (
        <Card>
            <Tree selectable={false} treeData={treeData} defaultExpandAll />
        </Card>
    );
};

export default CtsSettingTabInsuranceProduct;
